module.exports = __webpack_public_path__ + "img/GE.e36cc6d4.svg";